
export default function SQLs_Drop_DB() {
  return (
    <div>
      <h1>SQL Drop DB</h1>
      <p>Content for SQL Drop DB will go here.</p>
    </div>
  );
}
